// extracted by mini-css-extract-plugin
export default {"components":"CodeExamples_components__EvNCI","text":"CodeExamples_text__3UzlZ","toc":"CodeExamples_toc__zogre","componentContainer":"CodeExamples_componentContainer__rrXNV"};